import {
  CreateCustomerInput,
  DeleteCustomerDocumentsInput,
  DeleteCustomersInput,
  GetCustomerDocumentsInput,
  GetQueryProps,
  AddNewCustomerNoteInput,
  UpdateCustomerDefaultSla,
  UpdateCustomerContactsInput,
  UpdateCustomerNote,
} from "shared";
import { axiosClient } from "utilz";
import {
  apiErrorHandler,
  generateUrlString,
  getMspId,
  getQueryDataObject,
} from "utilz/helpers";

export const customerSearch = async (searchQuery: string) => {
  try {
    const response = await axiosClient.get("/v1/customers/search", {
      params: {
        searchQuery,
        per_page: 2000,
        page: 1,
      },
    });
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw resData?.message;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getCustomerById = async (id: string) => {
  try {
    const response = await axiosClient.get(`/v2/customers/${id}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
export const getAllCustomers = async ({
  perPageCount = 1000,
  pageNumber = 1,
  sortColumn,
  sortDirection = "asc",
  filter,
  searchQuery,
}: GetQueryProps) => {
  try {
    const data = await getQueryDataObject({
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    });

    const url = await generateUrlString({
      baseUrl: "/v2/customers",
      data,
    });

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const createCustomer = async (data: CreateCustomerInput) => {
  try {
    const url = "/v2/customer";
    // const url = `/v2/customer/${getMspId()}`;

    const response = await axiosClient.post(url, data);
    const resData = response?.data;
    if (resData?.statusCode === 200 && resData?.success === true) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getAllCustomerCityByMspId = async () => {
  try {
    const url = "/filter/city/customer?sortColumn=city&sortDirection=asc";
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
export const getCustomerDocuments = async ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection = "asc",
  filter,
  searchQuery,
  customerId,
}: GetCustomerDocumentsInput) => {
  try {
    const data = await getQueryDataObject({
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    });

    const url = await generateUrlString({
      // baseUrl: `/customer/attachments/${customerId}`,
      baseUrl: `/v2/customers/${customerId}/attachments`,
      data,
    });

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteCustomerDocument = async ({
  customerId,
  attachmentIds,
}: DeleteCustomerDocumentsInput) => {
  try {
    // const url = "/customer/delete/attachments";
    const url = "/v2/attachments/customer";
    const response = await axiosClient.patch(`${url}`, {
      attachment_ids: attachmentIds,
    });
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteCustomers = async ({
  customerIds,
}: DeleteCustomersInput) => {
  try {
    const url = `/deactivate/customer/${getMspId()}`;
    // const url = `/v2/customers/status`;
    const response = await axiosClient.patch(`${url}`, {
      customer_ids: customerIds,
    });
    const resData = response.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    } else {
      throw resData?.message;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateCustomerBillingInvoice = async ({
  customerIdParams,
  data,
}: any) => {
  try {
    // const url = `/update/customer/billing/invoice/${customerId}`;
    const url = `v2/customers/invoice/settings/${customerIdParams}`;
    const response = await axiosClient.patch(url, data);
    const resData = response.data;
    if (resData.statusCode === 200 && resData.success === true) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (e: any) {
    apiErrorHandler(e);
  }
};

export const getCustomerBillingInvoice = async ({
  customerIdParams,
  is_customer_overview = true,
}: {
  customerIdParams: string | number;
  is_customer_overview?: boolean;
}) => {
  try {
    // let url = "";
    // if(is_customer_overview){
    //    url = `v2/customers/billing/invoice/${customerIdParams}?is_customer_overview=${is_customer_overview}`;
    // }else{
    //    url = `v2/customers/billing/invoice/${customerIdParams}`;
    // }
    const url = `v2/customers/billing/invoice/${customerIdParams}?is_customer_overview=${is_customer_overview}`;
    const response = await axiosClient.get(url);
    const resData = response.data;
    if (resData.statusCode === 200 && resData.success === true) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (e) {
    throw e;
  }
};

//get all customer note
type GetQueryPropsWithCustomerId = GetQueryProps & {
  customerId: string;
};
export const getCustomerNotes = async ({
  perPageCount = 100,
  pageNumber = 1,
  sortColumn,
  sortDirection = "asc",
  filter,
  searchQuery,
  customerId,
}: GetQueryPropsWithCustomerId) => {
  try {
    const data = await getQueryDataObject({
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    });
    const url = await generateUrlString({
      // baseUrl: `/fetch/customer/notes/${customerId}`,
      baseUrl: `/v2/customers/${customerId}/notes`,

      data,
    });

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//create customer note
export const addNewCustomerNote = async ({
  customerId,
  noteData,
}: AddNewCustomerNoteInput) => {
  try {
    // const url = `/create/customer/note/${customerId}`;
    const url = `/v2/customers/${customerId}/notes`;

    const response = await axiosClient.post(url, noteData);
    const resData = response?.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//add new customer document
export const addCustomerDocument = async ({ customerId, formData }: any) => {
  try {
    // const url = `/customer/attachments/${customerId}`;
    const url = `/v2/customers/${customerId}/attachments`;

    const response = await axiosClient.post(url, formData, {
      headers: { "Content-Type": "multipart/form-data" }, // Set the correct content type for FormData
    });
    const responseData = response.data;
    if (responseData.success && responseData.statusCode === 200) {
      return responseData.data; // Assuming responseData.data contains the added document data
    } else {
      throw new Error(responseData?.message || "Failed to add document");
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//edit customer document
export const editCustomerDocument = async ({
  attachment_id,
  data,
}: {
  attachment_id: string;
  data: any;
}) => {
  try {
    // const url = `/customer/update/description/attachments/${attachment_id}`;
    const url = `/v2/attachments/customer/${attachment_id}/description`;

    const response = await axiosClient.patch(url, data);
    const responseData = response.data;
    if (responseData.success && responseData.statusCode === 200) {
      return responseData.data;
    }
  } catch (error: any) {
    // throw error;
    apiErrorHandler(error);
  }
};

//update customer note
export const updateCustomerNote = async ({
  noteId,
  customerId,
  noteData,
}: UpdateCustomerNote) => {
  try {
    const url = await generateUrlString({
      baseUrl: `/update/customer/note/${noteId}`,
      data: {
        customer_id: customerId,
      },
    });
    const response = await axiosClient.patch(url, noteData);
    const responseData = response?.data;
    if (responseData.success && responseData.statusCode === 200) {
      return responseData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//delete customer notes
export const deleteBulkCustomerNotes = async ({
  noteIds,
}: {
  noteIds: string[];
}) => {
  try {
    const body = { note_ids: [...noteIds] };
    const url = "/note/deactivate/customer_note";
    // const url = "/v2/notes/customers/status";
    const response = await axiosClient.patch(url, body);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message || "Error deleting bulk customer notes");
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//get customer detials
export const getCustomerDetails = async ({
  customerId,
}: {
  customerId: string;
}) => {
  try {
    const url = `/v2/customers/${customerId}`;
    const response = await axiosClient.get(url);
    const resdata = response.data;
    if (resdata?.statusCode === 200 && resdata?.success === true) {
      return resdata?.data;
    }
    throw new Error("No data found");
  } catch (e: any) {
    apiErrorHandler(e);
  }
};

//update customer details
export const updateCustomerDetails = async ({
  customerId,
  bodyData,
}: {
  customerId: string;
  bodyData: any;
}) => {
  try {
    const url = `/v2/customers/${customerId}`;
    const response = await axiosClient.patch(url, bodyData);
    const resdata = response?.data;
    if (resdata?.statusCode === 200 && resdata?.success === true) {
      return resdata?.success;
    }
    // throw resdata?.message;
    throw response;
  } catch (e: any) {
    apiErrorHandler(e);
  }
};

//update logo
export const updateCustomerLogo = async ({
  customerId,
  file,
}: {
  customerId: string;
  file: any;
}) => {
  try {
    const url = `/v2/customers/${customerId}/logo`;
    const response = await axiosClient.post(url, file, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    const resdata = response.data;
    if (resdata?.statusCode === 200 && resdata?.success === true) {
      return resdata;
    }
    throw resdata?.message;
  } catch (e: any) {
    apiErrorHandler(e);
  }
};

//update logo
export const removeCustomerLogo = async ({
  customerId,
}: {
  customerId: string;
}) => {
  try {
    const url = `/v2/customers/${customerId}/logo`;
    const response = await axiosClient.patch(url, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    const resdata = response.data;
    if (resdata?.statusCode === 200 && resdata?.success === true) {
      return resdata?.success;
    }
    throw new Error("No data found");
  } catch (e) {
    throw e;
  }
};

export const updateCustomerDefaultSla = async ({
  customerId,
  slaId,
}: UpdateCustomerDefaultSla) => {
  try {
    const url = `/v1/customers/${customerId}/default/sla`;
    const data = { sla_id: slaId };
    const response = await axiosClient.patch(url, data);
    const resdata = response?.data;
    if (resdata?.statusCode === 200 && resdata?.success === true) {
      return resdata?.success;
    }
    throw new Error("No data found");
  } catch (e: any) {
    apiErrorHandler(e);
  }
};

export const updateCustomerContacts = async ({
  customerId,
  data,
}: UpdateCustomerContactsInput) => {
  try {
    const url = `/v2/customers/contacts/${customerId}`;
    const response = await axiosClient.patch(url, data);
    const resData = response?.data;
    if (resData?.statusCode === 200 && resData?.success) {
      return resData;
    }
    throw resData?.message;
  } catch (e: any) {
    // throw e;
    apiErrorHandler(e);
  }
};

export const changeCustomerStatus = async ({
  customerId,
  isActive,
}: {
  customerId: string;
  isActive: boolean;
}) => {
  try {
    const url = `/customers/status/${customerId}/${isActive}`;
    const response = await axiosClient.put(url);
    const resData = response?.data;
    if (resData?.statusCode === 200 && resData?.success) {
      return resData;
    }
    throw resData?.message;
  } catch (e: any) {
    apiErrorHandler(e);
  }
};

// get all customer users
// /v1/customers/external/contacts/:customer_id
export const getAllCustomerExternalContacts = async ({
  customerId,
  searchQuery,
}: {
  customerId: string;
  searchQuery: string;
}) => {
  try {
    const data = await getQueryDataObject({
      searchQuery,
      perPageCount: 2000,
      pageNumber: 1,
    });
    const url = await generateUrlString({
      baseUrl: `/v1/customers/external/contacts/${customerId}`,
      data,
    });
    const response = await axiosClient.get(url, {
      params: {
        searchQuery,
      },
    });
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
